import './PostContent.scss';

const PostContent = ({ dangerouslySetInnerHTML }) => {
  return <div className="PostContent" dangerouslySetInnerHTML={dangerouslySetInnerHTML}></div>;
};

export default PostContent;
